import React from 'react'
import { CCol, CContainer, CRow } from '@coreui/react-pro'
import { Link } from 'react-router-dom'
import { useSeo } from '../../../hooks/useSeo'

const Page404 = () => {
  useSeo({ title: 'Página no encontrada | DomicilApp' })

  return (
    <div className="min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6} className="text-center">
            <div className="display-3 fw-bold text-body">404</div>
            <h1 className="h4 text-body">No encontramos esta página</h1>
            <p className="text-body-secondary">Puede que el enlace esté mal escrito o que la página ya no exista.</p>
            <Link to="/dashboard" className="btn btn-dark">Ir al inicio</Link>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Page404
